import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Formik, Field } from "formik";
import { Link, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";

import {
  Form,
  Input,
  Button,
  Card,
  Alert,
  Typography,
  Row,
  Col,
  Select,
  Switch,
} from "antd";

import validators from "../../../../validators/validators";
import * as userActions from "../../../../actionCreators/User";
import * as propertyActions from "../../../../actionCreators/Property";
import { FormInputField } from "../../../../Components/FormInputField/FormInputField";
import PopupModal from "../../../../Components/PopupModal";

import "./style/addInspector.css";

const { Option } = Select;

const AddInspectors = ({
  history,
  addTaxInspectors,
  error,
  userSuccess,
  type,
  clearUserSuccess,
  circles,
  getCircles,
  getTaxInspectors,
}) => {
  const [status, setStatus] = React.useState(false);
  const [circle, setCircle] = React.useState(null);
  const [circleError, setCircleError] = React.useState(null);
  const [circlesList, setCirclesList] = React.useState([]);
  const [statusModalOpen, setStatusModalOpen] = React.useState(false);
  const [disableUser, setDisableUser] = React.useState(false);

  React.useEffect(() => {
    getCircles();
  }, []);

  React.useEffect(() => {
    if (circles.data !== null) {
      setCirclesList(circles.data);
    }
  }, [circles]);

  React.useEffect(() => {
    if (error) {
      setStatusModalOpen(true);
    }
  }, [error]);

  React.useEffect(() => {
    if (!error && userSuccess) {
      clearUserSuccess();
      getTaxInspectors({ page: 0, pageSize: 10 });
      let path = `/inspectors`;
      history.push(path);
    }
  }, [error, userSuccess]);

  const handleSubmitForm = async (values, actions) => {
    if (!circle) {
      setCircleError("Please select circle");
      return;
    }

    const addInspectorsObject = {
      ...values,
      status,
      circle_id: circle,
      disable_user: disableUser,
    };

    addTaxInspectors(addInspectorsObject);
  };

  const handleCircleChange = (value) => {
    setCircle(value);
    setCircleError(null);
  };

  const handleStatusChange = (value) => {
    setStatus(!value);
  };

  return (
    <div>
      <div className="header">
        <Typography className="heading">
          Tax Inspectors / Add Inspector
        </Typography>
      </div>
      <div className="site-card-border-less-wrapper">
        <Card bordered={false} className="add-card">
          <Formik
            initialValues={{
              full_name: "",
              cnic: "",
              phone: "",
              email: "",
            }}
            validationSchema={validators.inspector.inspectorSchema}
            validateOnChange={false}
            validateOnBlur={false}
            onSubmit={(values, actions) => handleSubmitForm(values, actions)}
            render={(formikProps) => {
              const { errors, isSubmitting, handleSubmit } = formikProps;

              return (
                <>
                  {Object.keys(errors).length > 0 && (
                    <Alert
                      message={
                        errors.full_name ||
                        errors.email ||
                        errors.cnic ||
                        errors.phone
                      }
                      type="error"
                      showIcon
                      className="column-error"
                    />
                  )}
                  {circleError && (
                    <Alert
                      message={circleError}
                      type="error"
                      showIcon
                      className="column-error"
                    />
                  )}
                  <Form onFinish={handleSubmit}>
                    <Row>
                      <Col span={12} className="column-left">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="full_name"
                          hideErrorMessage={true}
                          className="text-field"
                          labelText="Full Name"
                        />
                      </Col>
                      <Col span={12} className="column-right">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="cnic"
                          labelText="CNIC"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={12} className="column-left">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="email"
                          labelText="Email"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                      <Col span={12} className="column-right">
                        <Field
                          InputType={Input}
                          component={FormInputField}
                          name="phone"
                          labelText="Phone"
                          hideErrorMessage={true}
                          className="text-field"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={12} className="column-left">
                        <Field
                          className="circle-select"
                          InputType={Select}
                          component={FormInputField}
                          name="circle"
                          labelText="Circle"
                          hideErrorMessage={true}
                          onChange={handleCircleChange}
                        >
                          {circlesList.map((circle) => (
                            <Option value={circle.id}>{circle.name}</Option>
                          ))}
                        </Field>
                      </Col>
                      <Col span={12} className="column-status">
                        <Typography className="status-typography">
                          Status
                        </Typography>

                        <Switch
                          name="status"
                          valuePropName="status"
                          checked={!status}
                          onChange={handleStatusChange}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col span={12} className="column-buttons">
                        <Form.Item>
                          <Button
                            type="primary"
                            htmlType="submit"
                            loading={isSubmitting}
                            className={"saveFormButton"}
                          >
                            Save
                          </Button>
                        </Form.Item>
                        <Link to="/inspectors">
                          <Button type="link" className={"cancelFormButton"}>
                            Cancel
                          </Button>
                        </Link>
                      </Col>
                    </Row>
                    <PopupModal
                      title={
                        statusModalOpen &&
                        error.includes("email already exists")
                          ? "Error"
                          : "Activate User"
                      }
                      centered
                      visible={statusModalOpen}
                      onCancel={() => setStatusModalOpen(false)}
                      footer={[
                        <Button
                          key="cancel"
                          type="link"
                          onClick={() => setStatusModalOpen(false)}
                        >
                          CLOSE
                        </Button>,
                        statusModalOpen &&
                        error.includes("email already exists") ? null : (
                          <Button
                            key="submit"
                            type="link"
                            onClick={() => {
                              setDisableUser(true);
                              handleSubmit();
                              setStatusModalOpen(false);
                            }}
                          >
                            CONFIRM
                          </Button>
                        ),
                      ]}
                    >
                      <p>{error}</p>
                    </PopupModal>
                  </Form>
                </>
              );
            }}
          />
        </Card>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  user: { error, success, type, userSuccess },
  property: { circles },
}) => ({
  error,
  userSuccess,
  circles,
  success,
  type,
});

const mapDispatchToProps = (dispatch) => ({
  getCircles: bindActionCreators(propertyActions.getCircles, dispatch),
  addTaxInspectors: bindActionCreators(userActions.addTaxInspectors, dispatch),
  getTaxInspectors: bindActionCreators(userActions.getTaxInspectors, dispatch),
  clearUserSuccess: bindActionCreators(userActions.clearUserSuccess, dispatch),
});

AddInspectors.propTypes = {
  users: PropTypes.object.isRequired,
  addTaxInspectors: PropTypes.func.isRequired,
  getCircles: PropTypes.func.isRequired,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddInspectors)
);
